export const DRIVER_PORTAL_FLUORESCENT_ICON_CLASS_NAME = "fill-[#B7FF2A] text-[#064E3B] drop-shadow-[0_0_3px_rgba(183,255,42,0.95)]";

export const DRIVER_PORTAL_FLUORESCENT_BADGE_CLASS_NAME = "border-[#0B6B3A] bg-[#EFFFCA] text-[#064E3B] shadow-[0_0_8px_rgba(183,255,42,0.7)]";
